const sortable = (el, binding) => {
  let axis = binding.value.hasOwnProperty('axis') ? binding.value.axis : 'y'
  let handle = binding.value.handle || null
  let vectorItems = binding.value.items
  let onUpdate = binding.value.onUpdate

  $(el).sortable({
    // revert: true,
    axis: axis,
    handle: handle,
    items: '> *:not(.sortable-disabled)',
    start: function (event, ui) {
      ui.item.startpos = ui.item.index()
    },
    stop: function (event, ui) {
      var startPosition = ui.item.startpos
      var newPosition = ui.item.index()

      // binding.value.items
      if (vectorItems) {
        var item = vectorItems.splice(startPosition, 1)[0]
        vectorItems.splice(newPosition, 0, item)
      }

      // onUpdate
      if (onUpdate) {
        onUpdate(vectorItems, startPosition, newPosition)
      }

      return false
    }
  })

  $(el).disableSelection()
}

const checkHas = (el, binding) => {
  if ($(el).data('sortable')) $(el).sortable('refresh')
  else sortable(el, binding)
}

export default {
  update: function (el, binding, vnode) {
    checkHas(el, binding)
  },
  inserted: function (el, binding, vnode) {
    checkHas(el, binding)
  }
}



// WEBPACK FOOTER //
// ./src/directives/Sortable.js